
export const featuresListingColumns = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: 'Key',
    accessor: 'key',
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: 'Description',
    accessor: 'description',
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: 'Created At',
    accessor: 'created_at',
  },
  {
    Header: 'Updated At',
    accessor: 'updated_at',
  },
];
